var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Table',{attrs:{"columns":_vm.columns2,"data":_vm.list2,"size":"small","stripe":""}}),_c('div',{staticClass:"paging_style"},[_c('Page',{attrs:{"size":"small","total":_vm.total,"page-size":_vm.query.pageSize,"current":_vm.query.pageNumber,"show-total":"","show-elevator":""},on:{"on-change":_vm.handlePageNumberChange}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }